import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { TextContainer, Markdown, Caption } from '../../components'
import * as translationService from './../../services/translationService'
import * as ns from '../../services/networkService'
import moment from 'moment'
// import { Stack, TextField, MobileNumber, ButtonGroup, Button, DisplayText, TextContainer } from './../../components'

const PrivacyView = ({ user }) => {
  const [tac, setTac] = React.useState()
  React.useEffect(() => {
    if (user.tac.intake) {
      getTac(user.tac.intake.id)
    }
  }, [])

  const getTac = async id => {
    try {
      const { data: acceptedTac } = await ns.getAcceptedTac(id)
      setTac(acceptedTac.content)
    } catch (error) {
      console.log(error)
    }
  }

  return tac ? (
    <TextContainer>
      <Caption>
        {translationService.accountPrivacyDateAccepted()}: {moment(tac.acceptDate).format('LLL')}
      </Caption>
      <Markdown source={tac} />
    </TextContainer>
  ) : null
}
PrivacyView.propTypes = {
  user: PropTypes.any,
}
const mapStateToProps = ({ AuthReducer }) => {
  const { user } = AuthReducer
  return {
    user,
  }
}
// const mapDispatchToProps = dispatch => ({})
export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    // mapDispatchToProps,
  ),
)(PrivacyView)



// WEBPACK FOOTER //
// ./src/views/Profile/Privacy.js